
import { useQuery } from 'react-query';
import { setHeaders } from '../../../actions/User';
import * as config from '../../../app.config';
import axios from 'axios';


const getControlAnalysisOptions = async (plate_uuid) => {
    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/qc/analysis/control_analysis_options/${plate_uuid}`,
        { headers: headerConfig }
    );
    console.log(data);
    return data;
};

export default function useFetchControlAnalysisOptions(plate_uuid, options = {}) {
    return useQuery(['controlAnalysisOptions', plate_uuid], () => getControlAnalysisOptions(plate_uuid), options);
};


